import {ElMessage} from 'element-plus'
// 数组等分
export function arrayDivide(arr, num) {
    let index = 0
    let newArr = []
    while(index < arr.length) {
        newArr.push(arr.slice(index, index += num))
    }
    return newArr
}
// 获取相对路径
export function getUrlRelativePath() {
    let url = document.URL.toString()
    let arrUrl = url.split('//')
    let start = arrUrl[1].indexOf('/')
    let relUrl = arrUrl[1].substring(start)
    if(relUrl.indexOf("?") != -1) {
        relUrl = relUrl.split("?")[0]
    }
    return relUrl
}

export function formatNumber(n) {
    n = n.toString()
    return n[1] ? n : '0' + n
  }

// 日期格式化
export function formatTime(date) {
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    const hour = date.getHours()
    const minute = date.getMinutes()
    const second = date.getSeconds()

    return [year, month, day].map(formatNumber).join('/') + ' ' + [hour, minute, second].map(formatNumber).join(':')
  }
  
  // 年月日(xxxx-xx-xx)
  export function formatDate(date) {
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
  
    return [year, month, day].map(formatNumber).join('-')
  }
  
  // 年月(xxxx-xx)
  export function formatMonth(date) {
    const year = date.getFullYear()
    const month = date.getMonth() + 1
  
    return [year, month].map(formatNumber).join('-')
  }
  
  //获取星期
  export function formatWeek(date) {
    const week = date.getDay()
    const weeks = ["星期一", "星期二", "星期三", "星期四", "星期五", "星期六", "星期日"]
    return weeks[week - 1]
  }
  
  //获取时分
  export function formatHMS(date) {
    const hour = date.getHours()
    const minute = date.getMinutes()
    const second = date.getSeconds()
    return [hour, minute].map(formatNumber).join(':')
  
  }

  // 日期选择限制(暂时用不上……)
  export function datePickerLimit(Timetype, startTime, endTime) {
    if(Timetype == 'start' ) {
      if(endTime != '' && startTime.getTime() > endTime.getTime()) {
        ElMessage.error('开始时间不能晚于结束时间')
        return 11
      } else {
        return startTime
      }
    }
    if(Timetype == 'end') {
      if(startTime != '' && endTime.getTime() < startTime.getTime() ) {
        ElMessage.error('结束时间不能早于开始时间')
        return 22
      } else {
        return endTime
      }
    }
  }

// 精确计算
 // 加法
export function Numadd (arg1, arg2) {
  // let r1, r2, m
  // try {
  //   r1 = arg1.toString().split('.')[1].length
  // } catch (e) {
  //   r1 = 0
  // }
  // try {
  //   r2 = arg2.toString().split('.')[1].length
  // } catch (e) {
  //   r2 = 0
  // }
  // // Math.max(x, y)：返回 x 和 y 中的最高值
  // // Math.pow(x, y)： 返回 x 的 y 次幂
  // m = Math.pow(10, Math.max(r1, r2))
  // return (arg1 * m + arg2 * m) / m
  var r1, r2, m, c;
    try {
        r1 = arg1.toString().split(".")[1].length;
    }
    catch (e) {
        r1 = 0;
    }
    try {
        r2 = arg2.toString().split(".")[1].length;
    }
    catch (e) {
        r2 = 0;
    }
    c = Math.abs(r1 - r2);
    m = Math.pow(10, Math.max(r1, r2));
    if (c > 0) {
        var cm = Math.pow(10, c);
        if (r1 > r2) {
            arg1 = Number(arg1.toString().replace(".", ""));
            arg2 = Number(arg2.toString().replace(".", "")) * cm;
        } else {
            arg1 = Number(arg1.toString().replace(".", "")) * cm;
            arg2 = Number(arg2.toString().replace(".", ""));
        }
    } else {
        arg1 = Number(arg1.toString().replace(".", ""));
        arg2 = Number(arg2.toString().replace(".", ""));
    }
    return (arg1 + arg2) / m;
}
// 减法
export function Numsub (arg1, arg2) {
  let r1, r2, m, n
  try {
    r1 = arg1.toString().split('.')[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = arg2.toString().split('.')[1].length
  } catch (e) {
    r2 = 0
  }
  m = Math.pow(10, Math.max(r1, r2))
  // 动态控制精度长度
  n = (r1 >= r2) ? r1 : r2
  return ((arg1 * m - arg2 * m) / m).toFixed(n)
}
// 乘法
export function Nummul (arg1, arg2) {
  let m = 0
  let s1 = arg1.toString()
  let s2 = arg2.toString()
  try {
    m += s1.split('.')[1].length
  } catch (e) {}
  try {
    m += s2.split('.')[1].length
  } catch (e) {}
  return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m)
}
// 除法
export function Numdiv (arg1, arg2) {
  let t1 = 0
  let t2 = 0
  let r1, r2
  try {
    t1 = arg1.toString().split('.')[1].length
  } catch (e) {}
  try {
    t2 = arg2.toString().split('.')[1].length
  } catch (e) {}
  r1 = Number(arg1.toString().replace('.', ''))
  r2 = Number(arg2.toString().replace('.', ''))
  return mul((r1 / r2), Math.pow(10, t2 - t1))
}
// 弹窗移动
export default {
  bind(el, binding, vnode) {
      const dialogHeaderEl = el.querySelector('.el-dialog__header')
      const dragDom = el.querySelector('.el-dialog')
      dialogHeaderEl.style.cssText += ';cursor:move;'
      dragDom.style.cssText += ';top:0px;'
      console.log('dialogHeaderEl', dialogHeaderEl)

      // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
      const getStyle = (function() {
          if (window.document.currentStyle) {
              return (dom, attr) => dom.currentStyle[attr]
          }
          else {
              return (dom, attr) => getComputedStyle(dom, false)[attr]
          }
      })()

      dialogHeaderEl.onmousedown = (e) => {
          // 鼠标按下，计算当前元素距离可视区的距离
          const disX = e.clientX - dialogHeaderEl.offsetLeft
          const disY = e.clientY - dialogHeaderEl.offsetTop

          const dragDomWidth = dragDom.offsetWidth
          const dragDomHeight = dragDom.offsetHeight

          const screenWidth = document.body.clientWidth
          const screenHeight = document.body.clientHeight

          const minDragDomLeft = dragDom.offsetLeft
          const maxDragDomLeft = screenWidth - dragDom.offsetLeft - dragDomWidth

          const minDragDomTop = dragDom.offsetTop
          const maxDragDomTop = screenHeight - dragDom.offsetTop - dragDomHeight

          // 获取到的值带px 正则匹配替换
          let styL = getStyle(dragDom, 'left')
          let styT = getStyle(dragDom, 'top')

          if (styL.includes('%')) {
              styL = +document.body.clientWidth * (+styL.replace(/\%/g, '') / 100)
              styT = +document.body.clientHeight * (+styT.replace(/\%/g, '') / 100)
          }
          else {
              styL = +styL.replace(/\px/g, '')
              styT = +styT.replace(/\px/g, '')
          }

          document.onmousemove = function(e) {
              // 通过事件委托，计算移动的距离
              let left = e.clientX - disX
              let top = e.clientY - disY

              // 边界处理
              if (-(left) > minDragDomLeft) {
                  left = -minDragDomLeft
              }
              else if (left > maxDragDomLeft) {
                  left = maxDragDomLeft
              }

              if (-(top) > minDragDomTop) {
                  top = -minDragDomTop
              }
              else if (top > maxDragDomTop) {
                  top = maxDragDomTop
              }

              // 移动当前元素
              dragDom.style.cssText += `;left:${left + styL}px;top:${top + styT}px;`

              // emit onDrag event
              vnode.child.$emit('dragDialog')
          }

          document.onmouseup = function(e) {
              document.onmousemove = null
              document.onmouseup = null
          }
      }
  }
}


